// extracted by mini-css-extract-plugin
export default {"formField":"Mqa-z","error":"Nqa-z","disabled":"Oqa-z","fieldError":"Pqa-z","errorText":"Qqa-z","linkButton":"Rqa-z","noCode":"Sqa-z","button":"Tqa-z","acknowledgment":"Uqa-z"};